module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/gears-shadow.be46d250.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/gears-shadow.png
// module id = 3306
// module chunks = 11